import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import { Rules } from "../../types/integrations";
import { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Field, FieldLabel, FieldError } from "../ui/field";

interface FormPasswordProps {
  label: string;
  placeholder: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  rules: Rules;
  errors: FieldErrors<FieldValues>;
}

export const FormPassword = ({
  label,
  placeholder,
  name,
  register,
  rules,
  errors,
}: FormPasswordProps) => {
  const [show, setShow] = useState(false);

  return (
    <Field>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      <div className="relative">
        <Input
          id={name}
          type={show ? "text" : "password"}
          placeholder={placeholder}
          {...register(name, rules)}
          aria-invalid={!!errors[name]}
          className="pr-20"
        />
        <div className="absolute right-0 top-0 h-full flex items-center pr-1">
          <Button
            type="button"
            size="sm"
            variant="default"
            onClick={() => setShow(!show)}
            className="h-8 text-[13px] font-normal"
          >
            {show ? "Hide" : "Show"}
          </Button>
        </div>
      </div>
      {errors[name] && (
        <FieldError>{`${errors[name]?.message}`}</FieldError>
      )}
    </Field>
  );
};
